import React, { useState } from "react";

import * as S from "./style";

//import ArrowDownDark from '../../assets/images/arrow_dropdown-dark.svg';
import AccountGray from "../../../../img/account_filled-gray.svg";

import LogOutGray from "../../../../img/logout-gray.svg";
import DropdownMenu from "react-bootstrap/esm/DropdownMenu";
import { Dropdown } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import { useRef } from "react";
import api from "../../../../services/api";

export default function HeaderUserButton() {
  const history = useHistory();

  const [user, setUser] = useState("");
  const [email, setEmail] = useState("");
  const [isUserTemp, setIsUserTemp] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [pressed, setPressed] = useState(false);
  const dropdownRef = useRef<any>(null);

  function handleClickOutside(e: any) {
    if (
      dropdownRef.current &&
      dropdownRef.current !== null &&
      !dropdownRef.current.contains(e.target)
    ) {
      setPressed(false);
    }
  }
  useOutsideAlert(dropdownRef, handleClickOutside);

  useEffect(() => {
    const login = sessionStorage.getItem(
      `@${process.env.REACT_APP_ESTATE_ID}LoginUser`
    );
    const email = sessionStorage.getItem(
      `@${process.env.REACT_APP_ESTATE_ID}EmailUser`
    );

    const userTemp = sessionStorage.getItem(
      `@${process.env.REACT_APP_ESTATE_ID}TEMP_MATRICULA_NAME`
    );

    if (userTemp) {
      setUser(userTemp);
      setIsUserTemp(true);
      //setPermissao(-1);
    } else if (login) {
      setUser(login);
      if (email) setEmail(email);
    } else {
      getUserData();
    }
  }, []);

  async function getUserData() {
    try {
      const response = await api.get("/admin/json/userdata");
      // console.log(response.data);
      if (response.data.login) {
        //setLogin(response.data.login);

        if (response.data.login) {
          sessionStorage.setItem(
            `@${process.env.REACT_APP_ESTATE_ID}LoginUser`,
            response.data.login
          );
          setUser(response.data.login);
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function logout() {
    //return;

    try {
      const response = await api.get("/admin/logout");

      //console.log(response);

      if (response.status === 200) {
        history.replace("/");
      }
      history.replace("/");
      setTimeout(() => {
        window.location.reload();
      }, 100);
    } catch (error) {
      console.log(error);

      history.replace("/");

      setTimeout(() => {
        window.location.reload();
      }, 100);
    }
  }

  if (user.length > 0)
    return (
      <S.MenuContainer>
        <S.HeaderUserContainer>
          <Dropdown>
            <Dropdown.Toggle className="dropdown-toggle-categoria">
              <div className="header_user_flex">
                <span className="user_circle">{user.substr(0, 2)}</span>
                {
                  //<img alt='v' src={ArrowDownDark} />
                }
              </div>
            </Dropdown.Toggle>
            <DropdownMenu>
              <div className="pt-24 pl-24 pb-24">
                <div className="row-center">
                  <span className="dropdown_circle">{user.substr(0, 2)}</span>
                  <div className="user-info">
                    <p className="user-title">{user}</p>
                    <p className="user-email">
                      {email.length > 0 ? email : "-"}
                    </p>
                  </div>
                </div>
              </div>

              {!isUserTemp && (
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    history.push("/admin/usuario");
                  }}
                  className="row-center user-item-select pl-24"
                >
                  <img
                    style={{ width: 20, height: 20 }}
                    alt="v"
                    src={AccountGray}
                  />
                  <p className="select-label">Meu perfil</p>
                </div>
              )}
              <div
                onClick={(e) => {
                  e.preventDefault();
                  console.log("a");
                  logout();
                }}
                className="row-center user-item-select pl-24"
              >
                <img
                  style={{ width: 20, height: 20 }}
                  alt="v"
                  src={LogOutGray}
                />
                <p className="select-label">Sair</p>
              </div>

              {/*<Dropdown.Item
							onSelect={(e) => {
								history.push('/login');
							}}>
							Log out
						</Dropdown.Item>*/}
            </DropdownMenu>
          </Dropdown>
        </S.HeaderUserContainer>
      </S.MenuContainer>
    );

  return null;
}

function useOutsideAlert(ref: any, handleClickOutside: any) {
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref]);
}
